<div class="auth-layout-container">
    <router-outlet></router-outlet>
</div>
